import {ContainerModule} from '@theia/core/shared/inversify';
import {CommandContribution} from "@theia/core/lib/common";
import {TriggerPushCommandContribution} from "./trigger-push-command-contribution";

export default new ContainerModule((bind, _unbind, _isBound, rebind) => {
    bind(CommandContribution).to(TriggerPushCommandContribution).inSingletonScope();
});